const mental_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "CLINICAL FINDINGS",
         number: "2"
      },
      "maxLength":1000,
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_3[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].Page_3[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Relevant Social/Marital/Family History",
      "sub":"PRE-MILITARY, MILITARY, AND POST-MILITARY",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "HISTORY",
         number: "2A"
      },
      "maxLength":340,
      "options":[],
      "dbqName":"form1[0].Page_3[0].SocialMaritalFamilyHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Occuptational and Educational History",
      "sub":"PRE-MILITARY, MILITARY, AND POST-MILITARY",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "HISTORY",
         number: "2B"
      },
      "maxLength":340,
      "options":[],
      "dbqName":"form1[0].Page_3[0].OccupationalandEducationalHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Mental Health History",
      "sub":"To include prescribed medications and family mental health",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "HISTORY",
         number: "2C"
      },
      "maxLength":260,
      "options":[],
      "dbqName":"form1[0].Page_3[0].MentalHealthHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Legal and Behavioral History",
      "sub":"PRE-MILITARY, MILITARY, AND POST-MILITARY",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "HISTORY",
         number: "2D"
      },
      "maxLength":260,
      "options":[],
      "dbqName":"form1[0].Page_3[0].LegalandBehavioralHistory[0]",
      "answer":""
   },
   {
      "question":"Relevant Substance Abuse History",
      "sub":"PRE-MILITARY, MILITARY, AND POST-MILITARY",
      "type":"textarea",
      "show": true,
      "section": {
         page: "3",
         title: "HISTORY",
         number: "2E"
      },
      "options":[],
      "maxLength":250,
      "dbqName":"form1[0].Page_3[0].SubstanceAbuseHistory[0]",
      "answer":""
   },
   {
      "question":"Symptoms",
      "sub":"Please check all symptoms that apply to the Veteran's diagnosis(es)",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "height": "auto",
      "cols": 4,
      "section": {
         page: "4",
         title: "SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Depressed mood",
            "dbqName":"form1[0].Page_4[0].LevelC1[0]",
            "answer":""
         },
         {
            "main":"Anxiety",
            "dbqName":"form1[0].Page_4[0].LevelC2[0]",
            "answer":""
         },
         {
            "main":"Suspiciousness",
            "dbqName":"form1[0].Page_4[0].LevelC3[0]",
            "answer":""
         },
         {
            "main":"Panic attacks that occur weekly or less often",
            "dbqName":"form1[0].Page_4[0].LevelC4[0]",
            "answer":""
         },
         {
            "main":"Panic attacks more than once a week",
            "dbqName":"form1[0].Page_4[0].LevelD3[0]",
            "answer":""
         },
         {
            "main":"Near-continuous panic or depression affecting the ability to function independently, appropriately and effectively",
            "dbqName":"form1[0].Page_4[0].LevelE4[0]",
            "answer":""
         },
         {
            "main":"Chronic sleep impairment",
            "dbqName":"form1[0].Page_4[0].LevelC5[0]",
            "answer":""
         },
         {
            "main":"Mild memory loss, such as forgetting names, directions or recent events",
            "dbqName":"form1[0].Page_4[0].LevelC6[0]",
            "answer":""
         },
         {
            "main":"Impairment of short and long term memory, for example, retention of only highly learned material, while forgetting to complete tasks",
            "dbqName":"form1[0].Page_4[0].LevelD5[0]",
            "answer":""
         },
         {
            "main":"Memory loss for names of close relatives, own occupation, or own name",
            "subMain": "The distinction between “mild memory loss (such as forgetting names, directions, recent events)” found at the 30% level or “impairment of short- and long-term memory” found at the 50% level is that the Veteran will be unable to recall their own name and of immediate family members and their own occupation. This differs from occasionally forgetting or unable to find proper naming conventions. At this level, the Veteran cannot recall these memories at all.",
            "dbqName":"form1[0].Page_4[0].LevelF7[0]",
            "answer":""
         },
         {
            "main":"Flattened affect ",
            "dbqName":"form1[0].Page_4[0].LevelD1[0]",
            "answer":""
         },
         {
            "main":"Circumstantial, circumlocutory or stereotyped speech",
            "dbqName":"form1[0].Page_4[0].LevelD2[0]",
            "answer":""
         },
         {
            "main":"Speech intermittently illogical, obscure, or irrelevant",
            "dbqName":"form1[0].Page_4[0].LevelE3[0]",
            "answer":""
         },
         {
            "main":"Difficulty in understanding complex commands",
            "dbqName":"form1[0].Page_4[0].LevelD4[0]",
            "answer":""
         },
         {
            "main":"Impaired judgment",
            "dbqName":"form1[0].Page_4[0].LevelD6[0]",
            "answer":""
         },
         {
            "main":"Impaired abstract thinking",
            "dbqName":"form1[0].Page_4[0].LevelD7[0]",
            "answer":""
         },
         {
            "main":"Gross impairment in thought processes or communication",
            "subMain":"“Gross” meaning all-encompassing or “total” impairment in thought processes/communication. The Veteran may be unable to communicate thoughts or have a consistent process in their thoughts",
            "dbqName":"form1[0].Page_4[0].LevelF1[0]",
            "answer":""
         },
         {
            "main":"Disturbances of motivation and mood",
            "dbqName":"form1[0].Page_4[0].LevelD8[0]",
            "answer":""
         },
         {
            "main":"Difficulty in establishing and maintaining effective work and social relationships",
            "dbqName":"form1[0].Page_4[0].LevelD9[0]",
            "answer":""
         },
         {
            "main":"Difficulty adapting to stressful circumstances, including work or a work like setting",
            "dbqName":"form1[0].Page_4[0].LevelE8[0]",
            "answer":""
         },
         {
            "main":"Inability to establish and maintain effective relationships",
            "dbqName":"form1[0].Page_4[0].LevelE9[0]",
            "answer":""
         },
         {
            "main":"Suicidal ideation",
            "dbqName":"form1[0].Page_4[0].LevelE1[0]",
            "answer":""
         },
         {
            "main":"Obsessional rituals which interfere with routine activities",
            "dbqName":"form1[0].Page_4[0].LevelE2[0]",
            "answer":""
         },
         {
            "main":"Impaired impulse control, such as unprovoked irritability with periods of violence",
            "dbqName":"form1[0].Page_4[0].LevelE5[0]",
            "answer":""
         },
         {
            "main":"Spatial disorientation",
            "dbqName":"form1[0].Page_4[0].LevelE6[0]",
            "answer":""
         },
         {
            "main":"Persistent delusions or hallucinations",
            "subMain":"Persistent more closely approximates near constant rather than recurrent. The Veteran may have near constant delusions/hallucinations",
            "dbqName":"form1[0].Page_4[0].LevelF2[0]",
            "answer":""
         },
         {
            "main":"Grossly inappropriate behavior",
            "subMain":"“Gross” meaning all-encompassing in all behaviors",
            "dbqName":"form1[0].Page_4[0].LevelF3[0]",
            "answer":""
         },
         {
            "main":"Persistent danger of hurting self or others",
            "subMain":"Passive or active suicidal or homicidal ideations do not qualify at this level unless it is deemed “persistent” or near constant",
            "dbqName":"form1[0].Page_4[0].LevelF4[0]",
            "answer":""
         },
         {
            "main":"Neglect of personal appearance and hygiene",
            "dbqName":"form1[0].Page_4[0].LevelE7[0]",
            "answer":""
         },
         {
            "main":"Intermittent inability to perform activities of daily living, including maintenance of minimal personal hygiene",
            "subMain":"ADL’s refer to eating, bathing, dressing and ambulation. At this level the Veteran may be intermittently unable to perform their ADL’s.",
            "dbqName":"form1[0].Page_4[0].LevelF5[0]",
            "answer":""
         },
         {
            "main":"Disorientation to time or place",
            "subMain":"The Veteran may be unable to focus on the time, place or activities in the current moment with considerable confusion. There may be a distortion of time and lose their sense of place.",
            "dbqName":"form1[0].Page_4[0].LevelF6[0]",
            "answer":""
         }
      ],
      "answer":""
   },

   {
      "question":"Does ##name## have any other symptoms attributable to mental disorders that are not listed in previous question?",
      "sub":"",
      "type":"yesno",
      "show" : true,
      "section": {
         page: "4",
         title: "OTHER SYMPTOMS",
         number: "4"
      },
      "maxLength":600,
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_4[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "textdbqName":"form1[0].Page_4[0].IfYesDescribe[0]",
      "textanswer":""
   },
   {
      "question":"Please discuss ##name##'s behavioral observations",
      "sub":"",
      "type":"textarea",
      "show": true,
      "section": {
         page: "4",
         title: "BEHAVIORAL OBSERVATIONS",
         number: "0"
      },
      "maxLength":1000,
      "options":[],
      "dbqName":"form1[0].Page_4[0].IfYesDescribe[1]",
      "answer":""
   },

   {
      "question":"Occupational and Social Impairment",
      "sub":"Which of the following best summarizes the Veteran's level of occupational and social impairment with regards to the mental diagnosis? (Check only one)",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "height": "auto",
      "cols": 2,
      "section": {
         page: "2",
         title: "OCCUPATIONAL AND SOCIAL IMPAIRMENT",
         number: "3A"
      },
      "questions":[
         {
            "main":"Occupational and social impairment due to mild or transient symptoms which decrease work efficiency and ability to perform occupational tasks only during periods of significant stress, or symptoms controlled by medication.",
            "dbqName":"form1[0].Page_2[0].DIAG[2]",
            "answer":""
         },
         {
            "main":"Occupational and social impairment with occasional decrease in work efficiency and intermittent periods of inability to perform occupational tasks, although generally functioning satisfactorily, with normal routine behavior, self-care, and conversation.",
            "dbqName":"form1[0].Page_2[0].DIAG[3]",
            "answer":""
         },
         {
            "main":"Occupational and social impairment with reduced reliability and productivity.",
            "dbqName":"form1[0].Page_2[0].DIAG[4]",
            "answer":""
         },
         {
            "main":"Occupational and social impairment with deficiencies in most areas, such as work, school, family relations, judgment, thinking, and/or mood.",
            "dbqName":"form1[0].Page_2[0].DIAG[5]",
            "answer":""
         },
         {
            "main":"Total occupational and social impairment.",
            "subMain": "“Total” as defined by the VA will be considered when there is impairment to which it is sufficiently impossible for the average person to maintain average earning capacity. This constitutes deficiencies in all areas such as work, school, family relations, judgment, thinking and mood",
            "dbqName":"form1[0].Page_2[0].DIAG[6]",
            "answer":""
         }
      ],
      "answer":""
   },
   
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "maxLength":1450,
      "section": {
         page: "5",
         title: "REMARKS",
         number: "7"
      },
      "options":[],
      "dbqName":"form1[0].Page_5[0].REMARKSIfany[0]",
      "answer":""
   }
 ]

 export default mental_questions ;
